import { QrApi } from "@/api/QrApi";
import { LoginQrReq, EnableQrReq } from "@/types/Qr";

export class QrService {

  /**
   * ログインQRの発行
   */
  public async getLoginQr(userId: number) {
    const api = new QrApi();
    const req: LoginQrReq = {
      userId: userId
    }

    try {
      const res = await api.getLoginQr(req);
      return res
    } catch (e: any) {
      throw e
    }
  }

  /**
   * QRコードが有効か検証
   */
  public async isEnableToken(userId:number, token: string) {
    const api = new QrApi();
    const req: EnableQrReq = {
      userId,
      token
    }
    try {
      const res = await api.isEnableToken(req);
      return res
    } catch (e: any) {
      throw e
    }
  }
}
